/** @typedef {'es'|'en'|'fr'|'de'|'pt'|'ru'} AppLocale */

export const APP_LOCALE_KEY = "app_locale";

/** Locales con mensajes cargados en i18n */
export const SUPPORTED_APP_LOCALES = /** @type {const} */ (["es", "en", "fr", "de", "pt", "ru"]);

/**
 * @returns {AppLocale | null}
 */
export function readPersistedLocale() {
  const raw = localStorage.getItem(APP_LOCALE_KEY);
  return SUPPORTED_APP_LOCALES.includes(/** @type {AppLocale} */ (raw)) ? raw : null;
}

/**
 * Pantalla login / invitado: localStorage si válido, si no español.
 * @returns {AppLocale}
 */
export function getInitialAppLocale() {
  return readPersistedLocale() || "es";
}

/**
 * Tras login: si no hay idioma guardado, según 2 primeros caracteres de VKORG.
 * @param {string | number | null | undefined} vkorg
 * @returns {AppLocale}
 */
export function localeFromVkorg(vkorg) {
  const prefix = String(vkorg ?? "").slice(0, 2);
  if (prefix === "54") return "pt";
  if (prefix === "08") return "es";
  if (prefix === "55") return "fr";
  return "es";
}
